import { render, staticRenderFns } from "./CourseEvaluationPage.vue?vue&type=template&id=0a5fe0ee&"
import script from "./CourseEvaluationPage.vue?vue&type=script&lang=ts&"
export * from "./CourseEvaluationPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports